import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'

import { defaultInstance } from 'services'

import { removeEmpty } from 'utils'
import { responseSuccess, responseError } from 'utils/response'

// const getStatuses = () => {
//   return [
//     { label: 'Active', value: true },
//     { label: 'Inactive', value: false },
//   ]
// }

// const statuses = getStatuses()

// const getStatusByValue = (value) => {
//   return _.find(statuses, { value })
// }

export const mapFieldGroupAttribute = (item, index) => {
  return {
    index,
    key: uuidv4(),
    id: item?.report_header_id,
    topic: item?.incident_topic,
    reporter: item?.reporter?.employee?.employee_name_en,
    risk_owner: item?.riskcoordinator?.employee?.employee_name_en,
    report_type: item?.report_type?.report_type_name,
    close_match: item?.close_match
  }
}

export const getCloseMatch = (report_header_id,{amount_of_return}) => {

  const params = removeEmpty({
    amount_of_return
  })

  const config = {
    method: 'get',
    url: `/api/v1/close_match/${report_header_id}`,
    params,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (_.size(res.data) >= 0 && _.isArray(res.data)) {
        return responseSuccess({
          data: _.map(res.data, mapFieldGroupAttribute),
        })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}
